import { createSlice } from "@reduxjs/toolkit";

export const themeSlice = createSlice({
  name: "theme",
  initialState: {
    isDark: false,
    isFullScreen: false,
    isNavOpen: true,
  },
  reducers: {
    changeTheme: (state, { payload }) => {
      state.isDark = payload !== undefined ? payload : !state.isDark;
    },
    changeFullScreen: (state, { payload }) => {
      state.isFullScreen = payload;
    },
    changeNavOpen: (state, { payload }) => {
      state.isNavOpen = payload;
    },
  },
});

export const { changeTheme, changeFullScreen, changeNavOpen } = themeSlice.actions;

export default themeSlice;
